// InstructionCountNode shows a robot's instruction and the remaining
// number of that instruction.

import { InstructionType } from 'app/src/engine/Instruction';
import InstructionCountContainer from 'app/src/game/InstructionCountContainer';
import InstructionNode from 'app/src/game/InstructionNode';
import * as React from 'react';

type Props = {
	type: InstructionType;
	count: number;
	onClick?: () => void;
};

export default function InstructionCountNode({
	type,
	count,
	onClick,
}: Props): React.ReactElement | null {
	const disabled = !!(count === 0);

	return (
		<div className="InstructionCountNode">
			<button className="InstructionCountNode-button" onClick={onClick}>
				<InstructionNode type={type} disabled={disabled} />
			</button>
			<InstructionCountContainer count={count} />
		</div>
	);
}
